import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_fkd5r2mnj',
      userPoolClientId: '74iql9tllhac3i1mahrlk2v8jn',
      identityPoolId: 'us-east-1:2fe19ff3-1bbb-4662-8dba-c4b0c89f5899',
      loginWith: { // 👈 this is required to tell Amplify how users log in
        username: true,
        email: false,
        phone: false
      }
    }
  }
});